module.exports = __webpack_public_path__ + "static/media/queue.418c82ff.png";